import { Modal } from "antd";
import { rgba } from "config/variable";
import styled from "styled-components";

const ModalStyle = styled(Modal)`
  &.edit-contact-modal,
  &.add-cover-page-modal {
    .ant-modal-content {
      .ant-modal-header {
        margin-bottom: 10px;
      }
    }
    .ant-form-item {
      @media (min-width: 0px) and (max-width: 820px) {
        margin-bottom: 5px;
      }
      .ant-form-item-label {
        padding: 0;
      }
    }
  }
  .anticon-infoicon {
    color: ${(props) => props.theme.colordanger};
  }
  .ant-modal-content {
    padding: 24px;
    @media (min-width: 0px) and (max-width: 820px) {
      padding: 15px;
    }
    .edit-fax-wrapper {
      background: ${(props) => rgba(props.theme.bgborderlight ?? "", 0.36)};
      border: 1px solid ${(props) => props.theme.bordercolordlightblue};
      box-shadow: inset 0px 0px 1px 1px
        ${(props) => rgba(props.theme.bgcolordwhite, 0.36)};
      border-radius: 8px;
      padding: 24px;
      margin: 15px 0;
      @media (min-width: 0px) and (max-width: 820px) {
        padding: 15px;
        .mobile-table-block {
          padding: 0;
        }
      }
    }
    .mobile-table-block {
      @media (min-width: 0px) and (max-width: 820px) {   
          padding: 0; 
          > div{
            margin-bottom: 0;
          }
      }
    }
    .faxdata-top {
      padding: 24px;
      background: ${(props) => props.theme.testblock};
      border: 1px solid ${(props) => props.theme.colorbluegreylight};
      border-radius: 8px;
      @media (min-width: 0px) and (max-width: 820px) {
        padding: 15px;
      }
    }
    .faxdata-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0;
      .ant-typography {
        margin-bottom: 0;
        .spanstyle {
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
    .modal-spinner {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .ant-modal-close {
      display: none;
    }
    .ant-modal-footer {
      display: flex;
      align-items: center;
      gap: 10px;
      justify-content: end;
      .footerright {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
      }
    }
    .spanstyle {
      font-size: 14px;
      line-height: 16px;
    }
    .ant-modal-header {
      margin-bottom: 25px;
      .description {
        font-weight: 500;
      }
      .modal-title-icon {
        font-size: 16px;
        display: flex;
        font-weight: normal;
        .anticon {
          font-size: 20px;
          margin-right: 18px;
        }
      }
    }
  }
`;

export default ModalStyle;
